import { Rule } from 'antd/es/form';
import { t } from 'i18next';
import { isValidIBAN } from 'ibantools';
import { EnhancedSelectOption } from 'common/components/EnhancedSelect/EnhancedSelect';

export const IBANFormItemRules: Rule[] = [
  {
    validator(_, value: string): Promise<any> {
      if (!value) return Promise.resolve();
      const trimmedVal = value.replace(/\s/g, '');
      if (!trimmedVal || isValidIBAN(trimmedVal)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(t('forms.validation.iban.invalid')!));
    },
    message: t('forms.validation.iban.invalid')!,
  },
];

export const filterByValueOrLabel = (options: EnhancedSelectOption[], searchValue: string): EnhancedSelectOption[] =>
  options
    .map((option) => ({ ...option, label: option.label.toLowerCase(), value: String(option.value).toLowerCase() }))
    .filter((option) => [option.label, option.value].some((entry) => entry.includes(searchValue.toLowerCase())));

export const isValidGUID = (str: string): boolean => {
  const regex = /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/;
  if (str == null) {
    return false;
  }
  return regex.test(str);
}

export const isValidNumberInRange = (value: string, low: number = 0, hight: number = 100): boolean => {
  if ((value.trim() === '') || (/[^0-9]/.test(value))) {
    return false;
  }

  const num: number = parseFloat(value);

  return !Number.isNaN(value) && num >= low && num <= hight;
}
